<button
  *ngIf="modalMode"
  #closeButton
  type="button"
  (click)="sendCloseEvent()"
  (keydown.enter)="sendCloseEvent()"
  (keydown.escape)="sendCloseEvent()"
  [attr.aria-label]="'configurator.closeModalLabel' | cxTranslate"
  class="d-flex justify-content-center align-items-center focusable icon-close"
  data-cy="iframe-close-icon"
  tabindex="0"
>
  <em class="focusable__element ds-cursor--pointer ds-color--white ds-icon--close ds-icon--big"></em>
</button>
